export const paths = {
  root: "/",
  signup: "/signup",
  login: "/login",
  bemVindo: "/bemVindo",

  //CAIXAS
  caixas: "/caixas",
  cadastrarCaixa: "/caixas/novo",
  editarCaixa: "/caixas/editar/:id",

  done: "/done",

  //PRODUTOS
  produtos: "/produtos",
  cadastrarProduto: "/produtos/novo",
  editarProduto: "/produtos/editar/:id",

  //SHOPIFY
  shopifyProdutos: "/shopify/produtos",
  formShopify: "/formShopify",

  //PEDIDOS
  importPedidos: "/pedidos",

  //COTACAO
  cotacao: "/cotacao",

  //DASHBOARD
  dashboard: "/dashboard",

  //NUVEMSHOP
  nuvemshopConectar: "/nuvemshop/conectar",
  nuvemshopConectado: "/nuvemshop-conectado",
  nuvemshopEmbedded: "/nuvemshop/embedded",

  //LOGOUT
  logout: "/logout",

  //STATUS PÚBLICO
  status: "/status",

  //DOCUMENTAÇÃO DE API PARA PARCEIROS
  apiDocs: "/api-docs",
};

export const adminPaths = {
  login: "/admin/login",
  dashboard: "/admin",
  clientes: "/admin/clientes",
  clienteDetalhe: "/admin/clientes/:id",
  envios: "/admin/envios",
  integracoes: "/admin/integracoes",
  comunicacao: "/admin/comunicacao",
  changelog: "/admin/changelog",
  roadmap: "/admin/roadmap",
  equipe: "/admin/equipe",
  logs: "/admin/logs",
  relatorios: "/admin/relatorios",
  salaOperacoes: "/admin/sala-operacoes",
  maquinaDoTempo: "/admin/maquina-do-tempo",
  chamados: "/admin/chamados",
  chamadoDetalhe: "/admin/chamados/:id",
  carteira: "/admin/carteira",
  regimes: "/admin/regimes",
};
